<div *ngIf="marker.isMyLocation" style="width: 20px; height: 20px; border-radius: 50%; background-color: rgba(0,0,0,0.5)">
</div>
<div *ngIf="!marker.isMyLocation">
  <img [src]="marker.iconType"/>
</div>
